import "./SpecialSlider.scss";
import { useSliderLogic } from "./SpecialSlider.logic";

const SpecialSlider = ({ children, className }) => {
  const {
    sliderRef,
    handleMouseDown,
    handleMouseLeave,
    handleMouseUp,
    handleMouseMove,
  } = useSliderLogic();

  return (
    <div
      ref={sliderRef}
      onMouseDown={(e) => handleMouseDown(e)}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={(e) => handleMouseMove(e)}
      className={`custom-slider ${className ? className : ""}`}
    >
      {children}
    </div>
  );
};
export default SpecialSlider;
